export default {
    showContacts: 'Показать контакты',
    lastActive: 'Последний активный',
    mostActive: 'Самый активный',
    lastAndMostActive: 'Последний и Самый активный',
};
